/* Tracks whether the next CTI socket disconnect was triggered intentionally. 
for example: the agent set their status to "Niet aan het werk", which makes the
server close the socket. When true, the disconnect handler in `log-in.js`
suppresses the "CTI verbinding verbroken" modal.
*/

let intentional = false;

export const markIntentionalDisconnect = () => {
  intentional = true;
};

export const consumeIntentionalDisconnect = () => {
  const value = intentional;
  intentional = false;
  return value;
};
